import styled from "styled-components";
import "../../styles/sass/Pages/_newDesign.scss";

export const Container = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
	font-family: "MetropolisRegular";
`;

export const Content = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	border-radius: 16px;
	background: #23242f;
	justify-content: center;
	flex-direction: column;
`;

export const DemonstrationLogin = styled.div`
	padding-bottom: 2rem;
	color: #fff;
`;

export const Info = styled.div`
	width: 37rem;
	height: 6.5rem;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;

	span {
		font-family: "MetropolisRegular";
		font-size: 16px;
	}

	b {
		font-family: var(--font-family-metropolis-semi-bold);
	}
`;

export const AccessQrCode = styled.div`
	width: 38.5rem;
`;

export const ContainerQRCode = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
`;
